document.addEventListener('deviceready', showAccessoryBar, false);


export function hideAccessoryBar() {
  const { Keyboard } = window;
  if (Keyboard && Keyboard.hideFormAccessoryBar)
    Keyboard.hideFormAccessoryBar(true);
}


export function showAccessoryBar() {
  const { Keyboard } = window;
  if (Keyboard && Keyboard.hideFormAccessoryBar)
    Keyboard.hideFormAccessoryBar(false);
}


window.addEventListener('keyboardWillShow', function() {
  document.documentElement.classList.add('keyboard-open');
});


window.addEventListener('keyboardWillHide', function() {
  document.documentElement.classList.remove('keyboard-open');
});


if (window.visualViewport) {
  window.visualViewport.addEventListener('resize', function() {
    const htmlEl = document.querySelector('html');

    htmlEl.style.height    = `${window.visualViewport.height}px`;
    htmlEl.style.marginTop = `${window.visualViewport.pageTop}px`;
  });
}
